import { render } from "./GooglePlayIcon.vue?vue&type=template&id=4e3c80dc&scoped=true"
const script = {}

import "./GooglePlayIcon.vue?vue&type=style&index=0&id=4e3c80dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_postcss@8.5.28_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3c80dc"]])

export default __exports__